// extracted by mini-css-extract-plugin
module.exports = {"card":"LoginForm_card___qTjL","submitButtonFormItem":"LoginForm_submitButtonFormItem__35rtL","submitButton":"LoginForm_submitButton__2yutx"};